import { Component, Input } from '@angular/core';
import { CategoryBasicView } from 'src/app/swagger-api';

@Component({
  selector: 'app-role-patient',
  templateUrl: './role-patient.component.html',
  styleUrls: ['./role-patient.component.scss'],
})
export class RolePatientComponent {
  @Input({ required: true }) public diseases: CategoryBasicView[];

  public readonly NOT_SPECIFIED_HINT: string = 'DISEASES_SPECIALTIES_LIST_NOT_SPECIFIED_HINT';
}
